import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CVEtable from "./CVEtable";
import http from "../services/httpService.js";
const { SERVER_BASE_URL } = require("../env");

function ProgramNewCVEPage() {
  const [newCVEs, setNewCVEs] = useState([]);
  const [program, setProgram] = useState([]);

  let { cpeId } = useParams();

  useEffect(() => {
    async function fetchData() {
      const response = await http.get(
        `${SERVER_BASE_URL}/my-cpes/${cpeId}/new-cves`,
        {
          headers: { "x-auth-token": localStorage.getItem("token") },
        }
      );
      setProgram(response.data.cpeTitle);
      setNewCVEs(response.data.newCVEs);
    }
    fetchData();
  }, []);

  return (
    <div className="centeral-container">
      <div className="mb-5 farsi-bold">
        آسیب‌پذیری‌های جدید برنامه {program}
      </div>
      <CVEtable items={newCVEs} cpeId={cpeId}></CVEtable>
    </div>
  );
}

export default ProgramNewCVEPage;
